import { useMsal } from '@azure/msal-react';
import React from 'react';
import { AuthError } from '@azure/msal-browser';

// import { PublicClientApplication, SilentRequest, AuthenticationResult, Configuration, LogLevel, AccountInfo, InteractionRequiredAuthError, RedirectRequest, PopupRequest, EndSessionRequest } from "@azure/msal-browser";

const GotoAusmed = ({orgCode, redirectToMyOrg}) => {
  const { instance } = useMsal();

  var request = {
    scopes: ['User.Read'],
  };
  // console.log('🚥 GotoAusmed');

  React.useEffect(() => {
    instance
      .acquireTokenSilent(request)
      .then((tokenResponse) => {
        if (tokenResponse && tokenResponse.accessToken) {
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ accessToken: tokenResponse.accessToken }),
          };
          return fetch(
            `${process.env.REACT_APP_accountServiceEndpoint}/authenticateMobile/azure`,
            requestOptions
          ) //environment.accountServiceEndpoint
            .then((response) => response.json())
            .then((data) => {
              if (data && data.token) {
                const prefix = redirectToMyOrg?`${process.env.REACT_APP_host}/browser-only/my-organisation/overview/${orgCode.toLowerCase()}`
                  : `${process.env.REACT_APP_host}`;

                // console.log('prefix:', prefix);

                window.location.href = `${prefix}?overwritingToken=${data.token}`;
                // console.log('🚥 success');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
        // console.log('🚥 no token');
        // return instance.logout();
        return;
      })
      .catch(async (error) => {
        console.log(error);
        if (error instanceof AuthError) {
          // fallback to interaction when silent call fails
          return instance.logout();
        }
      })
      .catch((error) => {
        console.log(error);
      });
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);

  return (
    
      <p className="text-center mt-5">You've already authenticated. Redirecting...</p>

  );
};

export default GotoAusmed;
